import script from "./TimeIntervalButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeIntervalButton.vue?vue&type=script&setup=true&lang=js"

import "./TimeIntervalButton.vue?vue&type=style&index=0&id=d3aa513c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3aa513c"]])

export default __exports__